import { TUser } from '../types/user';

export function canModerateAnnouncements(user: TUser): boolean {
  return user.isAuthenticated && user.permissions.canModerateAnnouncements;
}
